var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"donateLinks"}},[_c('button',{staticClass:"openChatBtn",on:{"click":function($event){return _vm.goDonatePage()}}},[_c('span',{staticClass:"mobileNoShow"},[_vm._v(" "+_vm._s(_vm.$t('donate.donateUs'))+" ")]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"deskNoShow"},[_c('i',{staticClass:"fa fa-tree"})])
}]

export { render, staticRenderFns }